import { ReactComponent as DesignIcon} from './images/designIcon.svg'
import { ReactComponent as ArtIcon} from './images/artIcon.svg'
import { ReactComponent as FashionIcon} from './images/fashionIcon.svg'
import { ReactComponent as EducationIcon} from './images/educationIcon.svg'
import { ReactComponent as StartupsIcon} from './images/startupsIcon.svg'
import { ReactComponent as DesignIconMedium} from './images/designIconMedium.svg'
import { ReactComponent as ArtIconMeduim} from './images/articonMedium.svg'
import { ReactComponent as FashionIconMedium} from './images/fashionIconMedium.svg'
import { ReactComponent as EducationIconMedium} from './images/educationIconMedium.svg'
import { ReactComponent as StartupsIconMedium} from './images/startupsIconMedium.svg'

export const ELEMENT_COLORS = [
    {
        name: 'edu_design',
        icon: {
            LargeIcon: DesignIcon,
            MediumIcon: DesignIconMedium
        },
        colors: {
            color: '#FF0000',
            hover: '#D00000'
        }
    },
    {
        name: 'edu_art',
        icon: {
            LargeIcon: ArtIcon,
            MediumIcon: ArtIconMeduim
        },
        colors: {
            color: '#FF6BFF',
            hover: '#E73EE7'
        },
    },
    {
        name: 'edu_fashion',
        icon: {
            LargeIcon: FashionIcon,
            MediumIcon: FashionIconMedium
        },
        colors:  {
            color: '#FF8C00',
            hover: '#DC7900'
        },
    },
    {
        name:'edu_education',
        icon: {
            LargeIcon: EducationIcon,
            MediumIcon: EducationIconMedium
        },

        colors:  {
            color: '#5C97FF',
            hover: '#4583EF'
        }
    },
    {
        name: 'edu_startups',
        icon: {
            LargeIcon: StartupsIcon,
            MediumIcon: StartupsIconMedium
        },
        colors:  {
            color: '#4EF100',
            hover: '#3FC200'
        }
    }
]import { ReactComponent as DesignIcon} from './images/designIcon.svg'
import { ReactComponent as ArtIcon} from './images/artIcon.svg'
import { ReactComponent as FashionIcon} from './images/fashionIcon.svg'
import { ReactComponent as EducationIcon} from './images/educationIcon.svg'
import { ReactComponent as StartupsIcon} from './images/startupsIcon.svg'
import { ReactComponent as DesignIconMedium} from './images/designIconMedium.svg'
import { ReactComponent as ArtIconMeduim} from './images/articonMedium.svg'
import { ReactComponent as FashionIconMedium} from './images/fashionIconMedium.svg'
import { ReactComponent as EducationIconMedium} from './images/educationIconMedium.svg'
import { ReactComponent as StartupsIconMedium} from './images/startupsIconMedium.svg'

export const ELEMENT_COLORS = [
    {
        name: 'edu_design',
        icon: {
            LargeIcon: DesignIcon,
            MediumIcon: DesignIconMedium
        },
        colors: {
            color: '#FF0000',
            hover: '#D00000'
        }
    },
    {
        name: 'edu_art',
        icon: {
            LargeIcon: ArtIcon,
            MediumIcon: ArtIconMeduim
        },
        colors: {
            color: '#FF6BFF',
            hover: '#E73EE7'
        },
    },
    {
        name: 'edu_fashion',
        icon: {
            LargeIcon: FashionIcon,
            MediumIcon: FashionIconMedium
        },
        colors:  {
            color: '#FF8C00',
            hover: '#DC7900'
        },
    },
    {
        name:'edu_education',
        icon: {
            LargeIcon: EducationIcon,
            MediumIcon: EducationIconMedium
        },

        colors:  {
            color: '#5C97FF',
            hover: '#4583EF'
        }
    },
    {
        name: 'edu_startups',
        icon: {
            LargeIcon: StartupsIcon,
            MediumIcon: StartupsIconMedium
        },
        colors:  {
            color: '#4EF100',
            hover: '#3FC200'
        }
    }
]